var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ValidationProvider',{class:_vm.classWrapper,attrs:{"name":_vm.name,"rules":_vm.rules,"tag":"div"}},[_c('label',{class:[
            'cb-container',
            `type${_vm.type}`,
            _vm.noMarginBottom && 'no-margin-bottom',
        ]},[_c('span',[_vm._v(_vm._s(_vm.label))]),_c('input',_vm._b({attrs:{"value":"1","id":_vm.name,"disabled":_vm.disabled,"type":"checkbox"},domProps:{"checked":_vm.value},on:{"input":_vm.onInput}},'input',_vm.$attrs,false)),_c('span',{class:['cb-checkmark', `type${_vm.type}`]})])])
}
var staticRenderFns = []

export { render, staticRenderFns }